import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { TAgentAccountType } from '../../../types/userData';
import { getProfileLinkLabel } from './utils/getProfileLinkLabel';

type TUserCardDesktopProfileLinkProps = {
  userProfileUrl: string;
  agentAccountType?: TAgentAccountType | null;
  onClick: () => void;
};

export const UserCardDesktopProfileLink: React.FC<TUserCardDesktopProfileLinkProps> = ({
  userProfileUrl,
  agentAccountType,
  onClick,
}) => {
  return (
    <div className={styles['container']}>
      <LinkButton
        theme="main_secondary"
        size="XS"
        href={userProfileUrl}
        target="_blank"
        rel="noreferrer"
        data-testid="UserCardDesktopProfileLink"
        onClick={onClick}
      >
        {getProfileLinkLabel(agentAccountType)}
      </LinkButton>
    </div>
  );
};
